<template>
  <div style="width: 300px;height: 100vh">
    <div @click="open('/','_self')" class="api_logo">
      <img src="../../assets/img/logo1.png">
    </div>
    <el-menu
      :default-active="menuIndex"
      class="el-menu-vertical-demo"
      :unique-opened="true"
      style="text-align: center"
    >
      <template v-for="(item,index) in menus">
        <el-submenu v-if="item.children && Object.keys(item.children).length!==0" :index="String(index)">
          <template slot="title">
            <div style="display: flex;align-items: center">
              <img :src="item.cover" v-if="menuIndex===String(index)" style="width: 20px;height: 20px"/>
              <img :src="item.url" v-else style="width: 20px;height: 20px"/>
              <span style="margin: 0 0 0 20px">{{ item.title }}</span>
            </div>
          </template>
          <el-menu-item :index="String(index)+'-'+String(sindex)"
                        v-for="(sitem,sindex) in item.children"
                        :key="sindex" @click="clickItem(index,sindex)">
            {{ sitem.name }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="String(index)" @click="clickItem(index,null)" v-else>
          <div style="display: flex;align-items: center">
            <img :src="item.cover" v-if="menuIndex===String(index)" style="width: 20px;height: 20px"/>
            <img :src="item.url" style="width: 20px;height: 20px" v-else/>
            <span slot="title">
              <span style="margin: 0 0 0 20px">{{ item.title }}</span>
              <el-badge v-if="item.route==='/message'&& msgNum>0" :value="msgNum" class="item"></el-badge>
            </span>
          </div>
        </el-menu-item>
      </template>
    </el-menu>
    <!--    <span class="version">v{{ packConfig.version }}</span>-->
  </div>
</template>

<script>
import bus from "../../utils/bus";
import linkPath from '../../config/linkpath'
import packConfig from '../../../package.json'

export default {
  data() {
    return {
      userInfo: {},
      activeIndex: '0',
      menuIndex: '0',
      childIndex: 0,
      menus: [
        {
          title: '用户中心',
          url: require('../../assets/img/center/menu/user.png'),
          cover: require('../../assets/img/center/menu/user1.png'),
          route: '/userCenter',
          children: []
        },
        {
          title: '我的消息',
          url: require('../../assets/img/center/menu/msg.png'),
          cover: require('../../assets/img/center/menu/msg1.png'),
          route: '/message',
          children: []
        },
        {
          title: '我的数据接口',
          url: require('../../assets/img/center/menu/data.png'),
          cover: require('../../assets/img/center/menu/data1.png'),
          route: '/myInterface',
          children: [
            {
              name: '数据接口',
              url: '/myInterface',
            },
            {
              name: '套餐购买',
              url: '/purchaseInterface',
            },
            {
              name: '套餐预警值', //这个菜单一定要放在套餐购买下面
              url: '/packageRemind',
            },
            {
              name: '数据包购买',
              url: '/datapacket',
            },
            {
              name: '短信服务',
              url: '/shortMessage',
            }
          ]
        },
        {
          title: '我的账户',
          url: require('../../assets/img/center/menu/account.png'),
          cover: './img/center/menu/account1.png',
          route: '/myAccount',
          children: [
            {
              name: '业务查询',
              url: '/personAccount',
            },
            {
              name: '业务充值',
              url: '/recharge',
            },
            {
              name: '金币明细',
              url: '/detailed',
            },
            {
              name: '金币到期设置',
              url: '/warningMoney',
            }
          ]
        },
        {
          title: '发票管理',
          url: require('../../assets/img/center/menu/billed.png'),
          cover: require('../../assets/img/center/menu/bill.png'),
          route: '/billing',
          children: [
            {
              name: '发票申请',
              url: '/billing',
            },
            {
              name: '发票列表',
              url: '/invoiceList',
            },
            {
              name: '发票信息管理',
              url: '/invoiceInfo',
            },
            {
              name: '寄送地址',
              url: '/invoiceAddress',
            },
            {
              name: '实名认证',
              url: '/authentication',
            }
          ]
        },
        {
          title: '意见反馈',
          url: require('../../assets/img/center/menu/feedback.png'),
          cover: require('../../assets/img/center/menu/feedback1.png'),
          route: '/feedback',
          children: []
        },
        {
          title: '用户设置',
          url: require('../../assets/img/center/menu/set.png'),
          cover: require('../../assets/img/center/menu/set1.png'),
          route: '/editInfo',
          children: [
            {
              name: '设置信息',
              url: '/editInfo',
            },
            {
              name: '修改密码',
              url: '/changePassword',
            },
            {
              name: '安全设置',
              url: '/securitySetting',
            }
          ]
        },
        {
          title: '会员优惠',
          url: require('../../assets/img/center/menu/vip.png'),
          cover: require('../../assets/img/center/menu/vip1.png'),
          route: '/uservip',
          children: []
        }
      ],
      msgNum: 0,
    }
  },
  created() {
    console.log(packConfig.version)
    bus.$off('updateUnread');
    bus.$on('updateUnread', () => {
      this.msgNum = localStorage.getItem('mess') ? JSON.parse(localStorage.getItem('mess')).message : 0;
    })
    this.msgNum = localStorage.getItem('mess') ? JSON.parse(localStorage.getItem('mess')).message : 0;
    this.defaultMenu();
    this.userInfo = JSON.parse(localStorage.getItem('data'));
    this.menus.forEach(item => {
      if (item.route === '/myInterface') {
        for (let i = 0; i < item.children.length; i++) {
          if (this.userInfo.hasCustom === 0 && this.userInfo.hasCombination === 0 && item.children[i].url === '/purchaseInterface') {
            item.children.splice(i, 2);
          }

          if (this.userInfo.hasDatapackage === 0 && item.children[i].url === '/datapacket') {
            item.children.splice(i, 1);
          }
        }
      }
    })
  },
  watch: {
    $route() {
      this.defaultMenu();
    }
  },
  methods: {
    open(url, target) {
      window.open(linkPath + url, target)
    },
    defaultMenu() {
      let pathArr = this.$route.path.split('/');
      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i].route.includes(pathArr[1])) {
          if (pathArr[2]) { //如果有二级菜单
            for (let j = 0; j < this.menus[i].children.length; j++) {
              if (this.menus[i].children[j].url.includes(pathArr[2])) {
                return this.menuIndex = String(i) + '-' + String(j)
              }
            }
          } else {
            return this.menuIndex = String(i)
          }
        }
      }
    },
    clickItem(i, si) {
      if (si === null) {
        this.menuIndex = String(i)
      } else {
        this.menuIndex = String(i) + '-' + String(si)
      }
      let pIndex = '';
      let childIndex = '';
      let url = '';
      if (this.menuIndex.includes('-')) {
        pIndex = this.menuIndex.split('-')[0];
        childIndex = this.menuIndex.split('-')[1];
      } else {
        pIndex = this.menuIndex
      }
      if (childIndex) {
        url = `${this.menus[pIndex].route}${this.menus[pIndex].children[childIndex].url}`
      } else {
        url = this.menus[pIndex].route
      }
      if (this.$route.path !== url) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style scoped>
.api_logo {
  padding-top: 45px;
  margin-bottom: 25px;
  text-align: center;

}

.el-menu-vertical-demo {
  padding: 20px 0;
  border-top: 1px solid #cac7c7;
}

.el-submenu__title * {
  font-size: 18px;
  color: #9ca8b4;
}

.el-menu-item * {
  font-size: 18px;
  color: #9ca8b4;
}

.el-menu-item img, .el-submenu img {
  margin: 0 10px 0 30px;
}

.el-submenu .el-menu-item {
  font-size: 18px;
  color: #9ca8b4;
  /*padding-left: 132px!important;*/
  /*text-align: left;*/
}

.el-menu-item.is-active {
  background-color: #6da3e9;
  color: #FFFFFF !important;
}

.el-menu-item.is-active span {
  /*background-color: #6da3e9;*/
  color: #FFFFFF !important;
}

.version {
  color: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/index.vue